<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/oRLKiA/tc-custom/buylink_9781501153938_cover.jpg?1709292633174?1730539807623" alt="This image is the cover for the book Negotiator"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Negotiator
      </h1>
      <p class="bookDescription body article font2">
        <b>Compelling, poignant, enlightening stories from former Senate Majority Leader George Mitchell about growing up in Maine, his years in the Senate, working to bring peace to Northern Ireland and the Middle East, and what he’s learned about the art of negotiation during every stage of his life.</b><br/><br/>It’s a classic story of the American Dream. George Mitchell grew up in a working class family in Maine, experiencing firsthand the demoralizing effects of unemployment when his father was laid off from a lifelong job. But education was always a household priority, and Mitchell embraced every opportunity that came his way, eventually becoming the ranking Democrat in the Senate during the administrations of George H.W. Bush and Bill Clinton.<br/><br/>Told with wit, frankness, and a style all his own, Senator Mitchell’s memoir reveals many insights into the art of negotiation. Mitchell looks back at his adventures in law and politics—including instrumental work on clean air and water legislation, the Iran-Contra hearings, and healthcare reform—as well as life after the Senate, from leading the successful Northern Ireland peace process, to serving as chairman of The Walt Disney Company, to heading investigations into the use of steroids in baseball and unethical activity surrounding the Olympic Games. Through it all, Senator Mitchell’s incredible stories—some hilarious, others tragic, all revealing—offer invaluable insights into critical moments in the last half-century of business, law, and politics, both domestic and international.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        George J. Mitchell
      </h2>
      
      <p class="authorDescription body article">George J. Mitchell served as a Democratic senator from Maine from 1980 to 1995 and Senate majority leader from 1989 to 1995. He was the primary architect of the 1998 Good Friday Agreement for peace in Northern Ireland, chairman of The Walt Disney Company, US Special Envoy for Middle East Peace, and the author of the <I>Mitchell Report</I> on the use of performance-enhancing drugs in baseball, as well as the books <I>The Negotiator</I> and <I>A Path to Peace</I>. He was awarded the Presidential Medal of Freedom in 1999.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Simon & Schuster
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3cb275e0